class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
  
      this.input = this.querySelector('[data-js-search-input]');
      this.predictiveSearchResults = this.querySelector('[data-js-search-results]');
      this.wiPopularContainer = this.querySelector('.WI-popular-container');
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));

      let WIdiv = this.querySelector('.MA-resultWrap');
      let WIinput = this.querySelector('[data-js-search-input]');
      let WIsearchresult = this.querySelector('.WI-search-results-overlay');
      
  
      this.input.addEventListener('focus', function() {
          WIdiv.style.display = 'block';
          WIsearchresult.classList.add('active');
      });
  
      document.addEventListener('click', function(event) {
            if(!WIdiv.contains(event.target) && event.target !== WIinput) {
                WIdiv.style.display = 'none';
                WIsearchresult.classList.remove('active');
            }
        });
      

    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.wiPopularContainer.style.display = 'block';
        this.predictiveSearchResults.style.display = 'none';
        return;
      }
      else{
        this.getSearchResults(searchTerm);
      }
    }
  
    getSearchResults(searchTerm) {
      let url = `/search/suggest?q=${searchTerm}&section_id=helper-predictive-search`;

      // if (Shopify.currency.active == "SEK") {
      //   url = "/sv-se" + url;
      // }

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-js-search-results-holder]').innerHTML;
          this.wiPopularContainer.style.display = 'none';
          this.predictiveSearchResults.style.display = 'block';
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.productWishPreload();
        })
        .catch((error) => {
          this.wiPopularContainer.style.display = 'block';
          this.predictiveSearchResults.style.display = 'none';
          throw error;
        });
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
    // Preload all the product which is stored
    productWishPreload() {
          if (localStorage.getItem('productHandleArray') !== null) {
              var allwishlist = JSON.parse(localStorage.getItem('productHandleArray'));
              for (let i = 0; i < allwishlist.length; i++) {
                  var wish = "wish_" + allwishlist[i];
                  var wish_remove = "wish_remove_" + allwishlist[i];
                  var wishElement = document.getElementById(wish);
                  var wishRemoveElement = document.getElementById(wish_remove);
                  if (wishElement && wishRemoveElement) {
                      wishElement.style.display = "none";
                      wishRemoveElement.style.display = "flex";
                  } else {
                      
                  }
              }
          }
      };
  }
  
  customElements.define('predictive-search-new', PredictiveSearch);
  